import { useOpenTimeTrackingMask } from '../../time-tracking-mask/hooks';
import { CopyButtonCell } from '../CopyButtonCell';

type Props = {
  value: number;
};

export const TimeTrackingCopyButtonCell = ({ value }: Props) => {
  const openTimeTrackingMask = useOpenTimeTrackingMask();

  return (
    <CopyButtonCell
      onClick={() => {
        openTimeTrackingMask({ id: value, mode: 'clone' });
      }}
    />
  );
};
